import React from 'react'
import { Circle } from 'react-feather'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

function CustomSwitchGroup({
  options = [],
  onChange = () => {},
  value,
  mobile,
  small,
  space = 0,
}) {
  return (
    <CustomSwitchGroup.Container mobile={mobile} small={small}>
      {options.map(
        ({
          label,
          value: optValue,
          color = 'secondary',
          icon: Icon = Circle,
        }) => (
          <CustomSwitchButton
            key={optValue}
            selected={optValue === value}
            color={color}
            onClick={() => onChange(optValue)}
            className={`mx-${space}`}
          >
            <Icon size={18} />
            <FormattedMessage id={label} />
          </CustomSwitchButton>
        )
      )}
    </CustomSwitchGroup.Container>
  )
}

const CustomSwitchButton = styled.button`
  outline: 0;
  background: none;
  border: 0;
  color: ${props => (props.selected ? props.color : '#8D8D8D')};
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 7px;

  &:focus {
    outline: 0;
  }
`

CustomSwitchGroup.Container = styled.div`
  display: flex;
  flex-wrap: nowrap;
  overflow: auto;
  flex-direction: ${props => (props.mobile ? 'row' : 'column')};
  align-items: ${props => (props.mobile ? 'center' : 'flex-start')};
  justify-content: flex-start;

  button {
    font-size: ${props => (props.small ? 16 : props.mobile ? 20 : 16)}px;
    min-width: ${props => (props.mobile ? 'max-content' : 'unset')};
  }

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
`

export default CustomSwitchGroup
